"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const browser_tracker_1 = require("@snowplow/browser-tracker");
const index_1 = require("../../index");
/**
 * Defines a useEffect that will instantiate a new snowplow tracker
 */
function useSnowplowTracker(params) {
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const snowplow = (0, index_1.useSnowplowListener)();
    (0, react_1.useEffect)(() => {
        (0, snowplow_js_common_1.snowplowTracker)(params);
        if (snowplow !== undefined) {
            setIsReady(true);
        }
        return () => {
            (0, browser_tracker_1.clearGlobalContexts)();
        };
    }, [params.appId, snowplow]);
    return isReady;
}
exports.default = useSnowplowTracker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU25vd3Bsb3dUcmFja2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3JlYWN0L2hvb2tzL3VzZVNub3dwbG93VHJhY2tlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlDQUE0QztBQUM1QyxpRUFBMkQ7QUFFM0QsK0RBQWdFO0FBQ2hFLHVDQUFrRDtBQUVsRDs7R0FFRztBQUNILFNBQVMsa0JBQWtCLENBQUMsTUFBNkI7SUFDckQsTUFBTSxDQUFDLE9BQU8sRUFBRSxVQUFVLENBQUMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFFOUMsTUFBTSxRQUFRLEdBQUcsSUFBQSwyQkFBbUIsR0FBRSxDQUFDO0lBRXZDLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDWCxJQUFBLG9DQUFlLEVBQUMsTUFBTSxDQUFDLENBQUM7UUFDeEIsSUFBSSxRQUFRLEtBQUssU0FBUyxFQUFFO1lBQ3hCLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUNwQjtRQUVELE9BQU8sR0FBRyxFQUFFO1lBQ1IsSUFBQSxxQ0FBbUIsR0FBRSxDQUFDO1FBQzFCLENBQUMsQ0FBQztJQUNOLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztJQUU3QixPQUFPLE9BQU8sQ0FBQztBQUNuQixDQUFDO0FBRUQsa0JBQWUsa0JBQWtCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useSnowplowTracker.ts